import {useEffect, useRef, useState} from 'react';
import {usePathname} from 'next/navigation';
import {useLazyGetSeoQuery} from 'modules/seo/services';
import {IBreadcrumb} from 'modules/seo/types';

export const useCatalogBreadcrumbs = (initialBreadcrumbs: IBreadcrumb[] = []) => {
    const pathname = usePathname();
    const [getSeo, {data: seoData, isLoading}] = useLazyGetSeoQuery();

    const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumb[]>(initialBreadcrumbs);

    const lastPathRef = useRef<string>('');
    const isInitialMountRef = useRef<boolean>(true);

    // обновляем breadcrumbs при изменении initialBreadcrumbs
    useEffect(() => {
        if (0 < initialBreadcrumbs.length) {
            const urlPath = pathname || '';
            setBreadcrumbs(initialBreadcrumbs);

            if (urlPath) {
                lastPathRef.current = urlPath;
            }

            isInitialMountRef.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialBreadcrumbs]);

    // обновляем breadcrumbs из кеша/ответа API
    useEffect(() => {
        if (seoData?.breadcrumbs) {
            setBreadcrumbs(seoData.breadcrumbs);
        }
    }, [seoData]);

    useEffect(() => {
        const urlPath = pathname || '';

        if (!urlPath || '/' === urlPath) {
            return;
        }

        // пропускаем запрос при первой загрузке, если уже есть initialBreadcrumbs
        if (isInitialMountRef.current && 0 < initialBreadcrumbs.length) {
            isInitialMountRef.current = false;

            if (!lastPathRef.current) {
                lastPathRef.current = urlPath;
            }

            return;
        }

        // пропускаем запрос, если URL не изменился
        if (lastPathRef.current === urlPath) {
            return;
        }

        lastPathRef.current = urlPath;

        getSeo({
            type: 'plp',
            filter: {
                url: urlPath,
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return {breadcrumbs, isLoading};
};
